const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/team/index.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/team/index.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createCapabilityChecker } from '@/features/authentication/lib/authorizationCapabilities';
import { availableOperationsQuery } from '@/features/authentication/services/permissionQueries';
import { SupervisorTeamPendingState } from '@/features/supervisor/components/SupervisorTeamPendingState';
import { supervisorOverviewSearchSchema } from '@/features/supervisor/lib/search';
import { toSupervisorCamerasFilters, toSupervisorTeamScope } from '@/features/supervisor/lib/teamSearch';
import { supervisorCamerasQuery, supervisorMembersQuery, supervisorSummaryQuery } from '@/features/supervisor/services/supervisorQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/supervisor/team/')({
  validateSearch: supervisorOverviewSearchSchema,
  loaderDeps: ({
    search
  }) => ({
    scope: toSupervisorTeamScope(search),
    cameraFilters: toSupervisorCamerasFilters(search)
  }),
  loader: async ({
    context,
    deps
  }) => {
    const summaryQuery = supervisorSummaryQuery(deps.scope);
    const membersQuery = supervisorMembersQuery(deps.scope);
    const camerasQuery = supervisorCamerasQuery(deps.cameraFilters);
    const hasCachedSummary = context.queryClient.getQueryState(summaryQuery.queryKey)?.data !== undefined;
    const hasCachedMembers = context.queryClient.getQueryState(membersQuery.queryKey)?.data !== undefined;
    const hasCachedCameras = context.queryClient.getQueryState(camerasQuery.queryKey)?.data !== undefined;
    const summaryPromise = hasCachedSummary ? undefined : context.queryClient.ensureQueryData(summaryQuery);
    const availableOperations = await context.queryClient.ensureQueryData(availableOperationsQuery(context.authUid));
    const hasCapability = createCapabilityChecker(availableOperations);
    await Promise.all([summaryPromise, hasCachedMembers ? undefined : context.queryClient.prefetchInfiniteQuery(membersQuery), hasCapability('devices.read') && !hasCachedCameras ? context.queryClient.ensureInfiniteQueryData(camerasQuery) : undefined]);
  },
  pendingComponent: SupervisorTeamPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});